export default __webpack_public_path__ + "static/media/Stayery-SCT-Lost-Key-Card.ef8ce118.jpg";